import httpClient from './_httpClient';
import httpClientWithoutToken from "./_httpClientWithoutToken";

const END_POINT = '/languages';

const getAllLanguages = (paginated = true) => {
  let params = {};
  if (!paginated) {
    params.paginated = false;
  }
  return httpClientWithoutToken.get(END_POINT , {params})
};
const getAllLanguagesForConnectedScope = () => httpClientWithoutToken.get("languages-of-scope");
const addLanguage = (languageData) => httpClient.post(END_POINT, languageData);
const editLanguage = (id, languageData) => httpClient.put(END_POINT + '/' + id, languageData);
const deleteLanguage = (id) => httpClient.delete(END_POINT + '/' + id);

const importLanguage = (languageCode, jsonFile, onUploadProgress) => {
  let formData = new FormData();

  formData.append("languageCode", languageCode);
  formData.append("file", jsonFile);

  return httpClient.post(
    END_POINT + "/import",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress
    });
};

const exportLanguage = (languageCode,config) => httpClient.get(END_POINT + "/export/" + languageCode, config);

export {
  getAllLanguages,
  addLanguage,
  editLanguage,
  deleteLanguage,
  getAllLanguagesForConnectedScope,
  exportLanguage,
  importLanguage
}
